module.exports = __webpack_public_path__ + "fonts/fa-thin-100.da0900e6.ttf";